export default __webpack_public_path__ + "static/media/completed-checked.ed5f4ab4.svg";